import app from "../data/base";

async function saveGruppoRelatori(inputobject) {
  console.log(inputobject);
  const body = `${JSON.stringify(inputobject)}`;
  try {
    const response = await app.methods.callserver('api/speakergroup', 'POST', null, body, true);
  } catch (e) {
    console.error(e);
    throw e;
  }
}

async function deleteGruppoRelatori(idgrupporelatori) {
  try{
      console.log(idgrupporelatori);
      const response = await app.methods.callserver('api/speakergroup/' + idgrupporelatori,'DELETE',false, null);
      console.log(response)
      if(response.status=='201' || response.status=='200'){
          return true;
      }else{
          return false;
      }

  }catch(err){
      console.log('Error during saveUtente');
      console.log(err);
      return false;
  }
}

async function loadGruppiRelatori() {
  console.log('LoadGruppiRelatori')
  try {
    const response = await app.methods.callserver('api/speakergroup', 'GET', null, null, true);
    return await response.json();
  } catch (e) {
    console.error(e);
    throw e;
  }
}

async function loadGruppiRelatoriPerGruppo(idgruppo) {
  console.log('loadGruppiRelatoriPerGruppo')
  try {
    const response = await app.methods.callserver('api/speakergroup/group/' + idgruppo, 'GET', null, null, true);
    return await response.json();
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export const gruppi_relatori = {
  methods: {
    loadGruppiRelatori,
    loadGruppiRelatoriPerGruppo,
    saveGruppoRelatori,
    deleteGruppoRelatori
  }
}
